module.exports = __webpack_public_path__ + "static/media/verify_ico.173999b9.svg";